import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const instagramMenssegerRoot = (state: State) => state.instagramMensseger;

export const settingSelector = createSelector(
  instagramMenssegerRoot,
  (instagram) => instagram.settings
);

export const accountsSelector = createSelector(
  instagramMenssegerRoot,
  (instagram) => instagram.accounts
);

export const errorCodeSelector = createSelector(
  instagramMenssegerRoot,
  (instagram) => instagram.errorCode
);

export const errorMessageSelector = createSelector(
  instagramMenssegerRoot,
  (instagram) => instagram.errorMessage
);
